// [목적] 최대폭 1320 가운데 정렬 + 일관된 padding 적용 컨테이너
// [이유] design_structure §5 xl breakpoint — 데스크탑에서 콘텐츠 가운데
// [사이드 이팩트] 모든 페이지가 본 래퍼 안에 콘텐츠 배치
// [수정 시 고려사항] max width 변경 시 design_structure §5 표 동기화

import { Box, type BoxProps } from '@mui/material';
import type { PropsWithChildren } from 'react';

export function PageContainer({ children, sx, ...rest }: PropsWithChildren<BoxProps>): JSX.Element {
  return (
    <Box
      sx={{
        maxWidth: 1320,
        mx: 'auto',
        px: { xs: 2, md: 4 },
        py: { xs: 4, md: 6 },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
